if (!customElements.get('auren-size-guide')) {
  customElements.define('auren-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || this.ready) return;
      this.ready = true;
      this.scrollBody = this.querySelector('.auren-size-modal__body');
      // Only tables scroll sideways. Vertical gestures keep scrolling the guide.
      this.querySelectorAll('.auren-size-modal__content table').forEach(table => {
        if (table.parentElement.classList.contains('auren-size-modal__table-scroll')) return;
        const existingWrapper = table.parentElement.matches('.auren-size-guide__table-wrapper') ? table.parentElement : null;
        const wrapper = existingWrapper || document.createElement('div');
        wrapper.classList.add('auren-size-modal__table-scroll');
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', this.scrollBody?.getAttribute('aria-label') || this.dialog.getAttribute('aria-label') || 'Tableau des tailles');
        if (!existingWrapper) {
          table.before(wrapper);
          wrapper.append(table);
        }
      });
      this.onTrigger = event => {
        const trigger = event.target.closest?.('[data-auren-size-guide-open]');
        if (!trigger || trigger.getAttribute('aria-controls') !== this.dialog.id) return;
        event.preventDefault();
        this.trigger = trigger;
        this.dialog.showModal();
        if (this.scrollBody) this.scrollBody.scrollTop = 0;
        this.querySelectorAll('.auren-size-modal__table-scroll').forEach(wrapper => { wrapper.scrollLeft = 0; });
        document.body.classList.add('auren-size-help-open');
      };
      this.onClose = () => {
        if (!document.querySelector('auren-size-guide dialog[open]')) document.body.classList.remove('auren-size-help-open');
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
        this.closest('product-info')?.querySelector('auren-bundle')?.initStickyBar();
      };
      this.onDialogClick = event => {
        if (event.target.closest('[data-size-guide-close]')) this.dialog.close();
        else if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      };
      document.addEventListener('click', this.onTrigger);
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('click', this.onDialogClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onTrigger);
      this.dialog?.removeEventListener('close', this.onClose);
      this.dialog?.removeEventListener('click', this.onDialogClick);
      if (this.dialog?.open) this.dialog.close();
      if (!document.querySelector('auren-size-guide dialog[open]')) document.body.classList.remove('auren-size-help-open');
      this.ready = false;
    }
  });
}
